// Angular modules
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterStateSnapshot } from '@angular/router';
import { UrlTree } from '@angular/router';
import { Router } from '@angular/router';

// External modules
import { Observable } from 'rxjs';

// Services
import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor
    (
      private authService: AuthService,
      private apiService: ApiService,
      private router: Router
    ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const t = next.params;
    if ('refreshToken' in next.queryParams) {
      this.authService.signWithRefreshToken(
        next.params.businessprofileid,
        next.params.userid,
        next.queryParams.refreshToken).then((success) => {
          if (!success) {
            return Promise.resolve(false);
          } else {
            return this.authService.isAuthenticated();
          }
        }).then((authenticated) => {
          if (!authenticated) {
            this.router.navigate(['/sign-in']);
          } else {
            if ('deviceName' in next.queryParams) {
              this.router.navigate(['/device'], { queryParams: { deviceName: next.queryParams.deviceName } });
            } else if ('deviceIdentifier' in next.queryParams) {
              this.router.navigate(['/device'], { queryParams: { deviceIdentifier: next.queryParams.deviceIdentifier } });
            } else {
              this.router.navigate(['/device']);
            }
          }
          this.apiService.account().subscribe((account) => {
            sessionStorage.setItem('iot4bos.business-profiles', JSON.stringify(account.businessProfiles));
            const businessProfile = account.businessProfiles.find(bp => bp.id === next.params.businessprofileid);
            if (businessProfile !== null) {
              this.authService.selectBusinessProfile(businessProfile);
            }
          });
          return authenticated;
        });
    } else {
      return this.authService.isAuthenticated().then(authenticated => {
        if (!authenticated) {
          this.router.navigate(['/sign-in']);
        }
        this.apiService.account().subscribe((account) => {
          sessionStorage.setItem('iot4bos.business-profiles', JSON.stringify(account.businessProfiles));
        });
        return authenticated;
      });
    }
  }
}
